import React from "react";
import { Dictionary } from "lodash";
import { Person } from "@/features/people/graphql/generated";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { PDFDocument, PdfContainer } from "../../generator";
import { PersonSummary } from "./pages/PersonSummary";
import { HighlightsAndPersonality } from "./pages/Highlights";
import { Values } from "./pages/Values";
import { Competencies } from "./pages/Competencies";

interface PersonProfileProps {
  person: Person;
  summary?: string;
  dimensions: Dictionary<DimensionWithScores[]>;
}

function PersonProfilePdf(props: PersonProfileProps) {
  const { dimensions, person = {}, summary } = props;

  if (!person || !dimensions) return null;

  // Combine all pages
  const pages = [
    <PdfContainer className="relative px-4" key="container">
      <PersonSummary profile={person} summary={summary} />
      <HighlightsAndPersonality dimensions={dimensions} context="person" />
      <Values
        dimensions={dimensions}
        context="person"
        defaultPersonId={person.id!}
        person={person}
      />
      <Competencies
        dimensions={dimensions}
        context="person"
        person={person}
        defaultPersonId={person.id!}
      />
    </PdfContainer>,
  ];

  return <PDFDocument pages={pages} />;
}

export default PersonProfilePdf;
